import { toWorkflowData } from '@data/schemas/workflowData'
import { get } from 'lodash-es'

export const toCreatorOfferData = (data: unknown): CreatorOfferWorkflowData => {
    return {
        workflow: toWorkflowData(data),
        workflowType: 'creator-offer',
        user: get(data, '_embedded.user'),
    }
}
